/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { VisitorPageFAQ } from './visitorPageFAQ';


export interface VisitorPage { 
    archived?: boolean;
    createdAt?: string;
    faq?: VisitorPageFAQ;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    mapImage?: string;
    mapPdf?: string;
    mapTitle?: string;
    parkingHeader?: string;
    parkingTextLeft?: string;
    parkingTextMiddle?: string;
    parkingTextRight?: string;
    published?: boolean;
    readOnly?: boolean;
    updatedAt?: string;
    version?: number;
}
